import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'
import { AuthSessionChallenge } from '../../model'

export interface AuthSessionsFlowState {
  renderer?: boolean
  sessionRef?: string
  challenge?: AuthSessionChallenge
}

export const authSessionsFlowInitialState: AuthSessionsFlowState = {}

const authSessionsFlowSlice = createSlice({
  name: 'authSessionsFlow',
  initialState: authSessionsFlowInitialState,
  reducers: {
    setAuthSessionsRenderer: (state, action: PayloadAction<boolean>) => {
      state.renderer = action.payload
    },
    setAuthSessionsFlow: ({ renderer }, action: PayloadAction<Omit<AuthSessionsFlowState, 'renderer'>>) => ({ ...action.payload, renderer }),
    clearAuthSessionsFlow: ({ renderer }) => ({ renderer }),
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => authSessionsFlowInitialState)
  },
})

export const { setAuthSessionsRenderer, setAuthSessionsFlow, clearAuthSessionsFlow } = authSessionsFlowSlice.actions

export default authSessionsFlowSlice.reducer
